import * as React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import * as S from '../SellerVerification.styles' // Import your styles
import type { Path, FieldValues } from 'react-hook-form'

const RadioInput = <T extends FieldValues>({
  name,
  label,
  options,
  showError = true,
  loading = false
}: RadioInputProps<T>) => {
  const { watch } = useFormContext()
  const { field, fieldState } = useController({ name })

  return (
    <S.RadioInputContainer>
      {label && <S.FormLabel data-testid="radio-label">{label}</S.FormLabel>}

      {loading ? (
        <S.InputLoading data-testid="radio-loading" />
      ) : (
        <div>
          {options.map(({ value, label }) => (
            <S.RadioInput
              htmlFor={`${name}-${value}`}
              data-testid={`${name}-${value}`}
              checked={watch(name) === value}
              className="styled-label"
              key={value}
            >
              <input
                id={`${name}-${value}`}
                type="radio"
                {...field}
                value={value}
              />
              {label}
            </S.RadioInput>
          ))}
        </div>
      )}

      {fieldState.error && showError && (
        <S.FormHint error>{fieldState.error.message}</S.FormHint>
      )}
    </S.RadioInputContainer>
  )
}

export default RadioInput

interface RadioInputProps<T extends FieldValues> {
  name: Path<T>
  label?: string
  options: Array<{ label: string; value: string }>
  showError?: boolean
  loading?: boolean
}
